import { copyToClipboard } from '../../../../../../common/utils';
import { enumToTitleCase } from '../../../../../../utils/formatting';
import type { ErrorItem } from '../../types';

export const copyErrorsToClipboard = async (errorItems: ErrorItem[]): Promise<void> => {
  const copiedText = errorItems.reduce((acc, error) => {
    let errorString = `${enumToTitleCase(error.errorCode)}(${error.itemIds.length}). ${
      error.message
    } : ${error.itemIds.join(', ')}\r\n\r\n`;

    return acc + errorString;
  }, '');

  await copyToClipboard({ text: copiedText });
};
